import React, {useContext} from 'react';
import AppContext from '../store/index';
import './StickyArea.scss';
import PropTypes from "prop-types";
import useViewMode from "../hooks/useViewMode";

export const POSITION_LEFT = 'left';
export const POSITION_RIGHT = 'right';

export default function StickyArea({children, position = POSITION_RIGHT}) {
	const {
		isProductDetailsOpen,
		toggleProductsDetails,
		toggleStickyPanel,
	} = useContext(AppContext);
	const {isIsolateView} = useViewMode();
	const p = position === POSITION_RIGHT ? 'flex-end' : 'center';

	const handleStickyClick = () => {
		if(isProductDetailsOpen && !isIsolateView) {
			toggleProductsDetails(false)
		} else {
			toggleStickyPanel();
		}
	}

	return (
		<div className="sticky-container" style={{justifyContent: p}}>
			<div className="sticky-inner">
        <span
          onClick={handleStickyClick}
          className="sticky-toggle"
        />
				{children}
			</div>
		</div>
	)
}

StickyArea.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	position: PropTypes.oneOf([
		POSITION_LEFT,
		POSITION_RIGHT,
	])
}